import type { HTMLAttributeAnchorTarget } from "react"
import { Link, type To, type LinkProps } from "react-router-dom"

const RujiraLink = (
  props: LinkProps & React.RefAttributes<HTMLAnchorElement>,
) => {
  const mappedTo = handleMappedTo(props.to)

  if (typeof mappedTo === "string") {
    const isDoc = Object.values(docs).includes(mappedTo)
    const target: HTMLAttributeAnchorTarget | undefined = isDoc
      ? "_blank"
      : undefined
    return <a {...{ ...props, href: mappedTo, target }} />
  }

  if (!mappedTo) {
    return <a {...{ ...props, to: undefined }} />
  }

  return <Link {...props} to={mappedTo} />
}

const rujiraPath = (path: string) => {
  switch (window.location.host) {
    case "preview.rujira.network":
    case "testnet.rujiperps.com":
      return `https://preview.rujira.network${path}`
    case "rujira.network":
    case "rujiperps.com":
      return `https://rujira.network${path}`
    default:
      return path
  }
}

const handleMappedTo = (to: To) => {
  switch (to) {
    case "/portfolio":
      return rujiraPath("/portfolio")
    case "/swap":
      return rujiraPath("/swap/BTC.BTC/THOR.RUJI")
    case "/trade":
      return rujiraPath("/trade/RUJI/USDC")
    case "/index":
      return rujiraPath("/index")
    case "/options":
      return docs.options
    case "/stake":
      return undefined
    case "/strategies":
      return rujiraPath("/strategies")
    case "/liquidate":
      return docs.liquidate
    case "/launchpad":
      return docs.launchpad
    case "/borrow":
      return rujiraPath("/borrow")
    case "/mint":
      return undefined
    case "/ai":
      return "https://ai.autorujira.app"
    case "/dashboard":
      return undefined
    case "/buy":
      return undefined
    case "/leaderboard":
      return rujiraPath("/leaderboard")
    case "/games":
      return undefined
    case "/predict":
      return undefined
    case "/omniverse":
      return undefined
    case "/nfts":
      return docs.nfts
    case "/getstarted":
      return undefined
    case "/ecosystem":
      return rujiraPath("/ecosystem")
    case "/education":
      return undefined
    case "/developers":
      return docs.developers
    case "/support":
      return undefined
    case "/merge":
      return rujiraPath("/merge")
    case "/privacypolicy":
      return rujiraPath("/privacypolicy")
    case "/tou":
      return rujiraPath("/tou")
    case "/developer/tools":
      return undefined
    default:
      return to
  }
}

const docs = {
  options: "https://docs.rujira.network/core-products/ruji-options",
  liquidate: "https://docs.rujira.network/core-products/ruji-liquidations",
  launchpad: "https://docs.rujira.network/core-products/ruji-launchpad",
  nfts: "https://docs.rujira.network/core-products/ruji-collections-gojira",
  developers: "https://docs.rujira.network/developers/getting-started",
}

export default RujiraLink
